import '../../scss/pages/ErrorPages.scss';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Col, Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap';
import LanguageStore from '../../stores/LanguageStore';

interface NotFoundProps {
  languageStore: LanguageStore;
}

@inject(({ languageStore }) => ({ languageStore }))
@observer
export default class NotFound extends React.Component<NotFoundProps> {
  public render() {
    const translate = this.props.languageStore.translate;

    const title = translate(x => x.pages.errorPages.notFound.title);
    const subtitle = translate(x => x.pages.errorPages.notFound.subtitle);
    const quip = translate(x => x.pages.errorPages.notFound.quip);

    return <Col>
      <Card className="error-page">
        <CardBody >
          <CardTitle><b>404:</b> {title}</CardTitle>
          <CardSubtitle>{subtitle}</CardSubtitle>
          <CardText>{quip}</CardText>
        </CardBody>
      </Card>
    </Col >;
  }
}
